/* eslint-disable @typescript-eslint/no-explicit-any */

// import axios from 'axios'
// import 'bootstrap-umi/dist/js/bootstrap.min.js'
// import * as bootbox from 'bootbox'
// import { useMiiaFwStore } from '@/stores/miiaFwStore'
// import MiiaFwConfig from '@/configs/config'
// import QrcodeSvg from 'qrcode-svg'
// import EncodingJapanese from 'encoding-japanese'
// // import { errorMessage } from 'aws-sdk/clients/datapipeline'

import MiiaFwConfig from '@/configs/config'

// // 共通ストア(Vuex)
// /**
//  * @module modules/miiafw/MiiaFwUtils
//  * @description 汎用の機能を集めたMixin。
//  */

// /** 日時の情報をStringとして格納したオブジェクト */
// export interface DateTimeString {
//   result: {
//     /** 'YYYY' */
//     year: string
//     /** 'MM' */
//     month: string
//     /** 'DD' */
//     day: string
//     /** 'hh' */
//     hour: string
//     /** 'mm' */
//     minute: string
//     /** 'ss' */
//     second: string
//   }
// }

/** エラーメッセージが格納されているオブジェクト */
export interface ErrorMessage {
  error: string
}

// /** エラーメッセージが格納されているかどうか */
// export function isDateTimeStringError(obj: DateTimeString | ErrorMessage): obj is ErrorMessage {
//   return 'error' in obj
// }

// /**
//  * 日時テキスト化ライブラリ。Dateオブジェクトの要素をテキスト化して、年月日などの数字を文字列として持つオブジェクトを返す。
//  * @param date Date型オブジェクト
//  * @throws エラーが発生した場合、{error: '[エラーメッセージ]'}を返す。
//  */
// export function dateTimeStringLib(date: Date = new Date()): DateTimeString | ErrorMessage {
//   const dtList = date.toLocaleString().split(' ')
//   if (dtList.length !== 2) {
//     return { error: '日時をテキスト化できませんでした。(1)' }
//   }
//   let year = ''
//   let month = ''
//   let day = ''
//   if (dtList[0].includes('/')) {
//     // モダンブラウザ
//     const dateList = dtList[0].split('/')
//     if (dateList.length !== 3 || dateList[0].length !== 4) {
//       return { error: '日時をテキスト化できませんでした。(2)' }
//     }
//     year = dateList[0]
//     month = dateList[1].length === 1 ? '0' + dateList[1] : dateList[1]
//     day = dateList[2].length === 1 ? '0' + dateList[2] : dateList[2]
//   } else if (dtList[0].includes('年') && dtList[0].includes('月') && dtList[0].includes('日')) {
//     // IE対応
//     const tempY = dtList[0].split('年')
//     year = tempY[0]
//     const tempM = tempY[1].split('月')
//     month = tempM[0].length === 1 ? '0' + tempM[0] : tempM[0]
//     const tempD = tempM[1].split('日')
//     day = tempD[0].length === 1 ? '0' + tempD[0] : tempD[0]
//   } else {
//     return { error: '日時をテキスト化できませんでした。(3)' }
//   }
//   const timeList = dtList[1].split(':')
//   if (timeList.length !== 3) {
//     return { error: '日時をテキスト化できませんでした。(4)' }
//   }
//   const hour = timeList[0].length === 1 ? '0' + timeList[0] : timeList[0]
//   const minute = timeList[1].length === 1 ? '0' + timeList[1] : timeList[1]
//   const second = timeList[2].length === 1 ? '0' + timeList[2] : timeList[2]
//   return { result: { year: year, month: month, day: day, hour: hour, minute: minute, second: second } }
// }

// /**
//  * Date型をYYYY/MM/DD-hh:mm:ss形式の文字列に変換する。
//  * @param date Date型オブジェクト
//  * @returns YYYY/MM/DD/-hh:mm:ss
//  */
// export function dateTimeString(date: Date = new Date()): string {
//   const obj = dateTimeStringLib(date)
//   if (isDateTimeStringError(obj)) {
//     return obj.error
//   }
//   return (
//     obj.result.year +
//     '/' +
//     obj.result.month +
//     '/' +
//     obj.result.day +
//     '-' +
//     obj.result.hour +
//     ':' +
//     obj.result.minute +
//     ':' +
//     obj.result.second
//   )
// }

// /**
//  * 日付をテキスト化する(YYYY/MM/DD)。
//  * @param date Date型オブジェクト
//  * @returns YYYY/MM/DD
//  */
// export function dateString(date: Date = new Date()): string {
//   const obj = dateTimeStringLib(date)
//   if (isDateTimeStringError(obj)) {
//     return obj.error
//   }
//   return obj.result.year + '/' + obj.result.month + '/' + obj.result.day
// }

// /**
//  * 日時をテキスト化(YYYYMMDDhhmmss)する。
//  * @param date Date型オブジェクト
//  * @returns YYYYMMDDhhmmss
//  */
// export function dateTimeStringForUrl(date: Date = new Date()): string {
//   const obj = dateTimeStringLib(date)
//   if (isDateTimeStringError(obj)) {
//     return obj.error
//   }
//   return obj.result.year + obj.result.month + obj.result.day + obj.result.hour + obj.result.minute + obj.result.second
// }

// /** 和暦と西暦を文字列で格納したオブジェクト */
// export interface YearInfo {
//   /** 和暦（和暦YY年MM月DD日） */
//   kanji: string
//   /** 西暦（YYYYMMDD） */
//   western: string
// }

// /**
//  * コード（CCYYMMDD、CC:和暦、YY:年（和暦））から和暦と西暦、月日を取得する。
//  * eg. 95020411 -> {kanji: 令和2年4月11日, western: 20200411}
//  * @param code CCYYMMDD形式の文字列
//  * @returns  和暦：和暦YY年MM月DD日、西暦：YYYYMMDD
//  */
// export const codeToKanji = (code: string): YearInfo => {
//   if (code.length !== 8) {
//     throw new Error(`文字数が不正です。(${String(code.length)})`)
//   }
//   const meijiCode = '91'
//   const taishoCode = '92'
//   const showaCode = '93'
//   const heiseiCode = '94'
//   const reiwaCode = '95'
//   const nengoCode = code.slice(0, 2)
//   const year = parseInt(code.slice(2, 4), 10)
//   if (Number.isNaN(year)) {
//     throw new Error(`年の設定が不正です。(${code.slice(2, 4)})`)
//   }
//   const { warekiNengo, westernYear } = (() => {
//     if (nengoCode === meijiCode) {
//       return { warekiNengo: '明治', westernYear: 1868 + year - 1 }
//     } else if (nengoCode === taishoCode) {
//       return { warekiNengo: '大正', westernYear: 1912 + year - 1 }
//     } else if (nengoCode === showaCode) {
//       return { warekiNengo: '昭和', westernYear: 1926 + year - 1 }
//     } else if (nengoCode === heiseiCode) {
//       return { warekiNengo: '平成', westernYear: 1989 + year - 1 }
//     } else if (nengoCode === reiwaCode) {
//       return { warekiNengo: '令和', westernYear: 2019 + year - 1 }
//     } else {
//       throw new Error('非対応の年号です。')
//     }
//   })()
//   const month = parseInt(code.slice(4, 6), 10)
//   if (Number.isNaN(month)) {
//     throw new Error(`月の設定が不正です。(${code.slice(4, 6)})`)
//   }
//   const day = parseInt(code.slice(6, 8), 10)
//   if (Number.isNaN(day)) {
//     throw new Error(`日の設定が不正です。(${code.slice(6, 8)})`)
//   }
//   /** 和暦1年目の時は『元年』と表示する */
//   const nengoYearToString = (nengoYear: number): string => {
//     if (nengoYear === 1) {
//       return '元'
//     } else if (nengoYear < 10) {
//       return ' ' + nengoYear.toString()
//     } else {
//       return nengoYear.toString()
//     }
//   }
//   const strYear = nengoYearToString(year)
//   const strMonth = month < 10 ? ' ' + month.toString() : month.toString()
//   const strDay = day < 10 ? ' ' + day.toString() : day.toString()
//   return {
//     kanji: warekiNengo + strYear + '年' + strMonth + '月' + strDay + '日',
//     western: westernYear.toString() + code.slice(4, 8)
//   }
// }

// /** 和暦とその和暦コードを文字列で格納するオブジェクト */
// export interface JapaneseCarendarYear {
//   /** 和暦 */
//   kanji: string
//   /** コード */
//   code: string
// }

// /**
//  * 西暦を和暦に変換する。
//  * @param argDate Date型オブジェクトか、YYYYMMDD形式の文字列か、YYYY/MM/DD形式の文字列（明治以降である必要あり）
//  * @returns argDateがundefinedの場合、返り値なし。
//  * {kanji: '和暦YY年MM月DD日', code: 'CCYYMMDD'}を返す（CCは和暦コード）。
//  * @throws argDateが定義されていて、かつその内容がDate型オブジェクト、YYYYMMDD形式の文字列、YYYY/MM/DD形式の文字列のいずれでもない場合,エラーメッセージを表示
//  * @throws argDateが'1868-01-25T00:00:00+09:00'以前の場合、エラーメッセージを表示
//  */
// export function japaneseCalendar(argDate: undefined | Date | string): JapaneseCarendarYear {
//   const meijiCode = '91'
//   const taishoCode = '92'
//   const showaCode = '93'
//   const heiseiCode = '94'
//   const reiwaCode = '95'
//   const meijiStartDate = new Date('1868-01-25T00:00:00+09:00')
//   const taishoStartDate = new Date('1912-07-30T00:00:00+09:00')
//   const showaStartDate = new Date('1926-12-25T00:00:00+09:00')
//   const heiseiStartDate = new Date('1989-01-08T00:00:00+09:00')
//   const reiwaStartDate = new Date('2019-05-01T00:00:00+09:00')
//   let date = new Date()
//   if (argDate === undefined) {
//     // 処理なし
//   } else if (argDate instanceof Date) {
//     date = argDate
//   } else if (
//     typeof argDate === 'string' &&
//     argDate.length === 8 &&
//     !Number.isNaN(parseInt(argDate.slice(0, 4), 10)) &&
//     !Number.isNaN(parseInt(argDate.slice(4, 6), 10)) &&
//     !Number.isNaN(parseInt(argDate.slice(6, 8), 10))
//   ) {
//     date = new Date(`${argDate.slice(0, 4)}-${argDate.slice(4, 6)}-${argDate.slice(6, 8)}T00:00:00+09:00`)
//   } else if (
//     typeof argDate === 'string' &&
//     argDate.length === 10 &&
//     !Number.isNaN(parseInt(argDate.slice(0, 4), 10)) &&
//     !Number.isNaN(parseInt(argDate.slice(5, 7), 10)) &&
//     !Number.isNaN(parseInt(argDate.slice(8, 10), 10))
//   ) {
//     date = new Date(`${argDate.slice(0, 4)}-${argDate.slice(5, 7)}-${argDate.slice(8, 10)}T00:00:00+09:00`)
//   } else {
//     throw new Error(`引数が不正です。(${argDate})`)
//   }
//   let yearValue: number
//   if (date.getTime() >= reiwaStartDate.getTime()) {
//     yearValue = date.getFullYear() - reiwaStartDate.getFullYear()
//     return {
//       kanji:
//         '令和' +
//         (yearValue === 0 ? '元' : (yearValue + 1).toString()) +
//         '年' +
//         (date.getMonth() + 1 < 10 ? ` ${date.getMonth() + 1}` : date.getMonth() + 1).toString() +
//         '月' +
//         (date.getDate() < 10 ? ` ${date.getDate()}` : date.getDate()).toString() +
//         '日',
//       code:
//         reiwaCode +
//         (yearValue + 1).toString() +
//         (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1).toString() +
//         (date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()).toString()
//     }
//   } else if (date.getTime() >= heiseiStartDate.getTime()) {
//     yearValue = date.getFullYear() - heiseiStartDate.getFullYear()
//     return {
//       kanji:
//         '平成' +
//         (yearValue === 0 ? '元' : (yearValue + 1).toString()) +
//         '年' +
//         (date.getMonth() + 1 < 10 ? ` ${date.getMonth() + 1}` : date.getMonth() + 1).toString() +
//         '月' +
//         (date.getDate() < 10 ? ` ${date.getDate()}` : date.getDate()).toString() +
//         '日',
//       code:
//         heiseiCode +
//         (yearValue + 1).toString() +
//         (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1).toString() +
//         (date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()).toString()
//     }
//   } else if (date.getTime() >= showaStartDate.getTime()) {
//     yearValue = date.getFullYear() - showaStartDate.getFullYear()
//     return {
//       kanji:
//         '昭和' +
//         (yearValue === 0 ? '元' : (yearValue + 1).toString()) +
//         '年' +
//         (date.getMonth() + 1 < 10 ? ` ${date.getMonth() + 1}` : date.getMonth() + 1).toString() +
//         '月' +
//         (date.getDate() < 10 ? ` ${date.getDate()}` : date.getDate()).toString() +
//         '日',
//       code:
//         showaCode +
//         (yearValue + 1).toString() +
//         (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1).toString() +
//         (date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()).toString()
//     }
//   } else if (date.getTime() >= taishoStartDate.getTime()) {
//     yearValue = date.getFullYear() - taishoStartDate.getFullYear()
//     return {
//       kanji:
//         '大正' +
//         (yearValue === 0 ? '元' : (yearValue + 1).toString()) +
//         '年' +
//         (date.getMonth() + 1 < 10 ? ` ${date.getMonth() + 1}` : date.getMonth() + 1).toString() +
//         '月' +
//         (date.getDate() < 10 ? ` ${date.getDate()}` : date.getDate()).toString() +
//         '日',
//       code:
//         taishoCode +
//         (yearValue + 1).toString() +
//         (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1).toString() +
//         (date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()).toString()
//     }
//   } else if (date.getTime() >= meijiStartDate.getTime()) {
//     yearValue = date.getFullYear() - meijiStartDate.getFullYear()
//     return {
//       kanji:
//         '明治' +
//         (yearValue === 0 ? '元' : (yearValue + 1).toString()) +
//         '年' +
//         (date.getMonth() + 1 < 10 ? ` ${date.getMonth() + 1}` : date.getMonth() + 1).toString() +
//         '月' +
//         (date.getDate() < 10 ? ` ${date.getDate()}` : date.getDate()).toString() +
//         '日',
//       code:
//         meijiCode +
//         (yearValue + 1).toString() +
//         (date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1).toString() +
//         (date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()).toString()
//     }
//   } else {
//     throw new Error('明治以前の日付が入力されました。')
//   }
// }

// /**
//  * 整数の乱数を作成。
//  * @param max 乱数の範囲(eg. 3を入力すると0, 1, 2のうちどれかがランダムに返ってくる)
//  * @returns 0以上(len-1)以下の整数のうちどれか
//  */
// export function rand(max: number): number {
//   return Math.floor(Math.random() * Math.floor(max))
// }

// /**
//  * ランダム文字列を作成。
//  * @param len 文字列の長さ
//  * @returns 小文字(a-z)大文字(A-Z)数字(0-9)からなる長さlenの文字列
//  */
// export function randString(len: number): string {
//   // 生成する文字列に含める文字セット
//   const c = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
//   const cl = c.length
//   let r = ''
//   for (let i = 0; i < len; i++) {
//     r += c[Math.floor(Math.random() * cl)]
//   }
//   return r
// }

// /**
//  * StringからBase64へ変換する
//  * @param text Base64で使用できる文字で構成される文字列
//  * @returns Base64にエンコードされたASCII文字列
//  */
// export function toBase64(text: string): string {
//   return window.btoa(unescape(encodeURIComponent(text)))
// }

// /**
//  * Base64からStringへ変換する
//  * @param code Base64で表現されるASCII文字列
//  * @returns デコードされた文字列
//  */
// export function toText(code: string): string {
//   return decodeURIComponent(escape(window.atob(code)))
// }

// /**
//  * StringからBooleanへ変換する
//  * @param text 文字列
//  * @returns 'true'(大文字と小文字を区別しない)という文字列が引数に入れられた場合はtrueを、それ以外の文字列の場合はfalseを返す。
//  */
// export function toBoolean(text: string): boolean {
//   return text.toLowerCase() === 'true'
// }

/**
 * バイナリ文字列をバイナリデータ(ArrayBuffer)に変換(例: '\xe3\x81\x82' → 0xE3, 0x81, 0x82)
 * @param str バイナリ文字列(eg. '\xe3\x81\x82')
 * @returns strをバイナリデータに変換したもの。
 */
export function stringToArrayBuffer(str: string): ArrayBufferLike {
  // Uint16Arrayを使用するとCPU依存で結果が異なるため、Uint8Arrayを使用する。
  return Uint8Array.from(
    str.split('').map(c => {
      return c.charCodeAt(0)
    })
  ).buffer // 戻り値はArrayBuffer型になる。
}

/** ボタンの種類 */
export type ButtonKind =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark'

/** ボタンの設定値を格納するオブジェクト */
export interface ButtonParameter {
  /** ボタンに表示する文字 */
  label: string
  /**
   * ボタンのカラー({@link ButtonKind}から選択)
   * @default 'primary'
   */
  kind: ButtonKind
  /** ボタンを押したときに実行されるコールバック関数 */
  func?: () => any
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function alert(_message: string, _callback?: () => any): void {
  // ../MiiaFwCognito.ts のコンパイルを通すために関数だけ定義してexport
}

// /**
//  * アラートダイアログを表示する。
//  * @param message ダイアログに表示するメッセージ
//  * @param callback ダイアログを閉じた時に呼び出されるコールバック関数
//  */
// export function alert(message: string, callback?: () => any): void {
//   const btnParams: ButtonParameter[] = [
//     {
//       label: '確認',
//       kind: 'primary',
//       func: callback
//     }
//   ]
//   customBtnDialog('<p style="text-align: left;">' + message + '</p>', MiiaFwConfig.config.sysName, btnParams)
// }

export function confirm(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _message: string,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _okCallback: () => any,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _cancelCallback?: () => any
): void {
  // ../MiiaFWCognito.tsのコンパイルを通すために関数だけexport
}

// /**
//  * 確認ダイアログを表示する。
//  * @param message ダイヤログに表示する文字
//  * @param okCallback 確認ボタンを押した時に呼び出されるコールバック関数
//  * @param cancellCallback 閉じるボタンを押した時に呼び出されるコールバック関数
//  */
// export function confirm(message: string, okCallback: () => any, cancelCallback?: () => any): void {
//   if (cancelCallback === undefined) {
//     cancelCallback = () => {}
//   }
//   const btnParams: ButtonParameter[] = [
//     {
//       label: 'キャンセル',
//       kind: 'secondary',
//       func: cancelCallback
//     },
//     {
//       label: 'OK',
//       kind: 'info',
//       func: okCallback
//     }
//   ]
//   customBtnDialog('<p style="text-align: left;">' + message + '</p>', MiiaFwConfig.config.sysName, btnParams)
// }

/** ボタンのスタイル設定を格納するオブジェクト */
export interface ButtonStyleParameter {
  /** CSS セレクター */
  selector: string
  /** CSSスタイルの設定 */
  style: string
}

// /**
//  * 任意の数のボタンを持つ、bootboxを活用したダイアログを表示する。
//  * 特にダイアログのカスタマイズを行わないのであれば、alertやcomfirmを使うと良い。
//  * @param message htmlでマークアップされたメッセージ (eg. '<p style="text-align: left;">' + message + '</p>'
//  * @param title ダイアログのタイトル
//  * @param btnParams ボタンのカスタマイズ。搭載したいボタンの数だけ配列に格納する。
//  * @param styles ] CSSスタイル設定
//  */
// export function customBtnDialog(
//   message: string,
//   title: string,
//   btnParams: ButtonParameter[],
//   styles: ButtonStyleParameter[] = []
// ): JQuery<HTMLElement> {
//   if (btnParams.length === 0) {
//     throw new Error('[MiiaFW/customBtnDialog] ボタンが一つもないダイアログを開くことはできません。')
//   }

//   const btnStyle = {
//     primary: 'btn-primary',
//     secondary: 'btn-secondary',
//     success: 'btn-success',
//     danger: 'btn-danger btn-primary', // 閉じるにフォーカスが当たるようにする。
//     warning: 'btn-warning',
//     info: 'btn-info',
//     light: 'btn-light',
//     dark: 'btn-dark'
//   }
//   const buttons: { [key: string]: { label: string; className: string; callback?: () => any } } = {}
//   for (let i = 0; i < btnParams.length; i++) {
//     if (typeof btnParams[i] === 'object' && Object.prototype.hasOwnProperty.call(btnParams[i], 'label')) {
//       let kind = btnStyle.primary
//       if (
//         Object.prototype.hasOwnProperty.call(btnParams[i], 'kind') &&
//         Object.prototype.hasOwnProperty.call(btnStyle, btnParams[i].kind)
//       ) {
//         kind = btnStyle[btnParams[i].kind]
//       }
//       buttons[`${kind}-${i}`] = {
//         label: btnParams[i].label,
//         className: kind
//       }
//       if (Object.prototype.hasOwnProperty.call(btnParams[i], 'func') && typeof btnParams[i].func === 'function') {
//         buttons[`${kind}-${i}`].callback = btnParams[i].func
//       } else {
//         buttons[`${kind}-${i}`].callback = () => {}
//       }
//     } else {
//       console.error('ボタンパラメータが不正です。')
//       console.error(btnParams[i])
//     }
//   }
//   const dialog = bootbox.dialog({
//     message: message,
//     title: title,
//     buttons: buttons,
//     closeButton: false
//   })
//   if (Object.keys(buttons).length > 0) {
//     dialog.find('.modal-title')[0].style.cssText = 'margin: 0 auto;'
//     for (const elm of styles) {
//       dialog.find(elm.selector)[0].style.cssText = elm.style
//     }
//   }
//   return dialog
// }

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function setLoadingView(_enabled: boolean) {}

export function promptDialog(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _message: string,
  // inputType: BootboxPromptOptions['inputType'],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _inputType: string, // もともとBootstrap由来のコンポーネントに依存していたが、Bootstrapはオワコンなので積極的に外していく。
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _okCallBack: (password: string | null) => any,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _cancelCallback: () => any
  // size: BootboxPromptOptions['size'] = 'small'
): void {
  // ../MiiaFwCognito.tsのためにexport
}

// /**
//  * プロンプトダイアログ（入力ダイアログ）を表示する。
//  * @param message プロンプトダイアログに表示するメッセージ
//  * @param inputType 入力するデータの型(text, password, email, number, time, etc. 詳細はbootboxjs.comのドキュメント参照)
//  * @param okCallBack 入力に成功した際に行う動作。入力された値が関数の引数として入力される。
//  * @param cancelCallBack 入力に失敗またはキャンセルした際に行う動作
//  * @param size ダイアログボックスの横幅。'small'、'large', 'extra-Large'から選択。
//  */
// export function promptDialog(
//   message: string,
//   inputType: BootboxPromptOptions['inputType'],
//   okCallBack: Function,
//   cancelCallback: Function,
//   size: BootboxPromptOptions['size'] = 'small'
// ): void {
//   bootbox.prompt({
//     size,
//     inputType,
//     title: message,
//     callback: result => {
//       if (result === null) {
//         cancelCallback()
//       } else {
//         okCallBack(result)
//       }
//     }
//   })
// }

// /**
//  * 帳票印刷コンテンツの要素(1頁分)作成処理の本体。
//  * 帳票コンテンツを作成するメソッド'createPrintContents'や、
//  * 印刷画面を表示まで行うメソッド'printForm'が呼び出す。
//  * @param formFileUrl 帳票定義ファイルのパス(svgファイル)
//  * @param params ターゲットを変数名とするメンバとしてもつオブジェクト。帳票定義ファイルのターゲットに対して埋め込む文字を指定する（{[ターゲット名]: '[ターゲットに埋め込む文字]', ...}）。
//  * @returns 帳票定義体のターゲット文字列をparamsのものに置換したデータ。
//  * If rejected then { message: `Status Code: ${error.response.status}, Message: ${error.response.statusText}` }。
//  */
// async function createPrintContentsElm(formFileUrl: string, params: any): Promise<string> {
//   // パラメータを帳票定義体に適用する。
//   const applyParam = (data: any, params: { [x: string]: any }): any => {
//     let ret = data
//     // デフォルトでは最初の一致だけ、一致するもの全てを抽出するにはglobalフラグを有効にする。
//     // iは大文字小文字の違いを無視
//     const re = /@\{[^}]+\}/gi
//     const elms = ret.match(re)
//     Object.keys(elms).forEach(key => {
//       const value = elms[key]
//       const elm = value.match(/@\{(.+)\}/)[1]
//       if (Object.prototype.hasOwnProperty.call(params, elm)) {
//         // ターゲット文字列を置換
//         ret = ret.replace(value, params[elm])
//       } else {
//         ret = ret.replace(value, '')
//       }
//     })
//     return ret
//   }
//   return await new Promise((resolve, reject) => {
//     // 非同期処理での「window.open()」はポップアップブロックされる。
//     axios
//       .get(formFileUrl)
//       .then(response => {
//         const ret = applyParam(response.data, params)
//         resolve(ret)
//       })
//       .catch((error: { response: { status: string; statusText: string } }) => {
//         reject({ message: `Status Code: ${error.response.status}, Message: ${error.response.statusText}` })
//       })
//   })
// }

// /** 帳票定義体に埋め込む文字列を格納する */
// export interface ChohyoDefinition {
//   /** 帳票定義ファイルのパス */
//   path: string
//   /** ターゲットを変数名とするメンバとしてもつオブジェクト。帳票定義ファイルのターゲットに対して埋め込む文字・数値を指定する（{[ターゲット名]: '[ターゲットに埋め込む文字・数値]', ...}） */
//   params: { [key: string]: string | number }
// }

// /**
//  * 帳票印刷コンテンツを作成する。
//  * 印刷も含めるなら'printForm'メソッドを使用する。
//  * @param data 帳票データ。帳票定義体1ファイルごとにリストに追加する
//  * @returns 帳票定義体のターゲット文字列をparamsのものに置換したデータ（string）
//  * If rejected then { message: `status code: ${error.response.status}, message: ${error.response.statustext}` }。
//  */
// export async function createPrintContents(defs: ChohyoDefinition[]): Promise<string> {
//   const pageBreak = '<div class="new-page"></div>'
//   const prints = await Promise.all(defs.map(async def => await createPrintContentsElm(def.path, def.params)))
//   return prints.join(pageBreak)
// }

// /**
//  * 帳票定義体と置換パラメータから帳票印刷コンテンツを作成し、印刷ページを表示する。
//  * @param defs 帳票データ。帳票定義体1ファイルごとにリストに追加する
//  * @param data.path 帳票定義ファイルのパス
//  * @param title 印刷ページのタイトル（htmlのtitleタグの部分）
//  * @returns '印刷ダイアログが閉じられました。'.
//  * If rejected then { message: `Status Code: ${error.response.status}, Message: ${error.response.statusText}` }
//  * If rejected then { message: `Status Code: ${error.response.status}, Message: ${error.response.statusText}` }.
//  */
// export async function printForm(defs: ChohyoDefinition[], title = '印刷ページ'): Promise<string> {
//   const sub = window.open()
//   assert(sub)
//   const prefix =
//     '<!DOCTYPE html>' +
//     '<html lang="ja">' +
//     '<head>' +
//     '<meta charset="UTF-8">' +
//     `<title>${title}</title>` +
//     '<style>div.new-page { page-break-before: always; }</style>' +
//     '</head>' +
//     '<body>'
//   // scriptタグ内でscript閉じタグを記述できないので分割
//   // ただちにclose()すると印刷できない場合がある。
//   // const cmd1 = '<script setup lang="ts">window.print();setTimeout(window.close, 500);<'
//   // const cmd1 = '<script setup lang="ts">window.print();alert("印刷実行後、OKボタンをクリックしてください。\\n(印刷画面が閉じます。)");close()<'
//   const cmd1 = `<script setup lang="ts">
//                   (function() {
//                     const mediaPrint = window.matchMedia('print');
//                     mediaPrint.addListener(() => {
//                       if (mediaPrint.matches) {
//                         // 印刷前処理
//                       } else {
//                         // 印刷後処理
//                         window.close();
//                       }
//                     });
//                     window.print();
//                   }());<`
//   const cmd2 = '/script>'
//   return await new Promise((resolve, reject) => {
//     createPrintContents(defs)
//       .then(result => {
//         sub.document.write(prefix + result + cmd1 + cmd2 + '</body></html>')
//         resolve('印刷ダイアログが閉じられました。')
//       })
//       .catch(error => {
//         reject(error)
//       })
//   })
// }

// /**
//  * 文字列strのidx番目の文字に文字列valを挿入する。
//  * @param str 元の文字列
//  * @param idx 挿入場所(idx番目とidx+1番目の文字の間)
//  * @param val 挿入する文字列
//  * @returns 挿入された後の文字列
//  */
// export function strIns(str: string, idx: number, val: string): string {
//   const ret = str.slice(0, idx) + val + str.slice(idx)
//   return ret
// }

/** XMLHttpRequestのレスポンスの型 */
const isResponseType = (str: string): str is XMLHttpRequestResponseType => {
  return (
    str === '' ||
    str === 'arraybuffer' ||
    str === 'blob' ||
    str === 'document' ||
    str === 'json' ||
    str === 'text'
  )
}

/**
 * XMLHttpRequestベースでWEB APIをコールする。
 * @param url 接続先のURL
 * @param method HTTPメソッド('get', 'post', 'head', 'put', 'delete')
 * @param headers リクエストヘッダの設定。日本語使用不可
 * @param data 送信するリクエスト。Json形式で記述する。
 * @param responseType レスポンス(data)の型。('arraybuffer', 'blob', 'document', 'json', 'text'。)
 * @param timeout 受信のタイムアウトまでの時間[msec]。デフォルトは一分。
 * @returns XMLHttpRequest.responseとレスポンスヘッダのContent-Typeの中身を';'で区切った配列で返す。
 * @throws {{message: '[エラーメッセージ]'}}
 */
export async function webApiCall(
  url: string,
  method: string,
  headers: { [key: string]: string | undefined },
  data: any,
  ignorecaseResponseType: string,
  timeout: number = 60000
): Promise<any> {
  // ブラウザが必要に応じてAccept-Encodingヘッダーを自動的に追加するので、DOM / JSレベルでこれを行う必要はない。
  // というか、XMLHttpRequestでHTTPヘッダ: Accept-Encodingを更新できない。(unsafe)
  return await new Promise((resolve, reject) => {
    const responseType = ignorecaseResponseType.toLowerCase()
    if (!isResponseType(responseType)) {
      return reject({
        message: 'Error: 不正なResponse Typeが指定されました。Response Type: ' + responseType
      })
    }
    const xhr = new XMLHttpRequest()
    // レスポンス受信が成功した時のハンドラ
    xhr.onload = () => {
      if (xhr.readyState === 4 && xhr.status === 200) {
        resolve(xhr.response)
      } else {
        reject({ message: `Error: サーバエラーを検出しました。Status Code: ${xhr.status}` })
      }
    }
    // レスポンス受信が失敗した時のハンドラ
    xhr.onerror = () => {
      reject({ message: `Error: データ受信に失敗しました。XMLHttpRequest Status: ${xhr.status}` })
    }
    // 各HTTPメソッド毎の処理
    if (method.toLowerCase() === 'get') {
      let qs = url
      if (data !== null) {
        qs += '?'
        Object.keys(data).forEach(key => {
          qs += `${key}=${data[key]}&`
        })
        qs = qs.slice(0, -1) // 最後の「&」を削除
      }
      xhr.open('GET', qs, true)
      xhr.responseType = responseType
      Object.entries(headers).forEach(([key, value]) => {
        if (value) xhr.setRequestHeader(key, value)
      })
      xhr.send(null)
    } else if (method.toLowerCase() === 'post') {
      xhr.open('POST', url, true)
      xhr.responseType = responseType
      xhr.setRequestHeader('Content-type', 'application/json')
      Object.entries(headers).forEach(([key, value]) => {
        if (value) xhr.setRequestHeader(key, value)
      })
      xhr.send(JSON.stringify(data))
    } else if (method.toLowerCase() === 'head') {
      xhr.open('HEAD', url, true)
      xhr.responseType = responseType
      Object.entries(headers).forEach(([key, value]) => {
        if (value) xhr.setRequestHeader(key, value)
      })
      xhr.send(null)
    } else if (method.toLowerCase() === 'put') {
      xhr.open('PUT', url, true)
      xhr.responseType = responseType
      Object.entries(headers).forEach(([key, value]) => {
        if (value) xhr.setRequestHeader(key, value)
      })
      // xhr.overrideMimeType(data.type)
      xhr.send(data)
    } else if (method.toLowerCase() === 'delete') {
      xhr.open('DELETE', url, true)
      xhr.responseType = responseType
      Object.entries(headers).forEach(([key, value]) => {
        if (value) xhr.setRequestHeader(key, value)
      })
      xhr.send(null)
    } else {
      reject({ message: 'Error: 不正なHTTPメソッドが指定されました。HTTP Method: ' + method })
    }
    // 受信タイムアウト処理
    setTimeout(() => {
      // タイムアウト時間になってもまだUNSENTまたはOPENEDだったらabortする。
      // UNSENT: 0 / OPENED: 0 / LOADING: 200 / DONE: 200
      if (xhr.status !== 200) {
        xhr.abort()
        reject({
          message: `Error: レスポンスタイムアウトです。XMLHttpRequest Status: ${xhr.status}`
        })
      }
    }, timeout)
  })
}

// /**
//  * ファイルのダウンロードを実行する。
//  * @param contests objectURL（href）
//  * @param name ダウンロードする時のファイル名
//  */
// export function downloadFile(contests: string, name: string): void {
//   if (getBrowser() !== 'ie') {
//     const link = document.createElement('a')
//     link.href = contests
//     link.download = name
//     link.click()
//   } else {
//     // IE対応
//     ;(window as any).navigator.msSaveOrOpenBlob(contests, name)
//   }
// }

// /**
//  * ヘッダ行のあるCSVをJSONに変換する。[開発中]
//  * @param csv CSVファイルの中身。改行コードはLF（\n)である必要がある。一行目はヘッダ行である必要がある。
//  * @param requiredKeys CSVのヘッダのカラムのリスト。csvにそのカラムが無ければエラーを出力する。
//  * @returns {result: [{(カラム名をkey, 値をvalueに持つレコード)}, {}, ...], error: '[エラーメッセージ(エラーがあれば)]'}。
//  */
// export function csv2Json(csv: string, requiredKeys?: string[]): any {
//   const array: any[] = []
//   const lines = csv.split(/\r\n|\r|\n/)
//   const head = lines.shift()
//   assert(head, 'head should be non-null')
//   const keys = head.split(/\t|,/)
//   let maxKeyIndex = 0
//   if (requiredKeys !== undefined && requiredKeys instanceof Array) {
//     for (let k = 0; k < requiredKeys.length; k++) {
//       const keyIndex = keys.indexOf(requiredKeys[k])
//       if (keyIndex === -1) {
//         return { error: 'マスタCSVに必須カラム: ' + requiredKeys[k] + 'がありません。' }
//       }
//       if (maxKeyIndex < keyIndex) {
//         maxKeyIndex = keyIndex
//       }
//     }
//   }
//   for (let i = 0; i < lines.length; i++) {
//     if (lines[i] !== '') {
//       const cols = lines[i].split(/\t|,/)
//       if (cols.length < maxKeyIndex + 1) {
//         return { error: `${i + 2}行目の要素が不足しています。` }
//         // 0スタート且つヘッダ分を考慮して2を加算 }
//       }
//       const line: any = {}
//       for (let j = 0; j < cols.length; j++) {
//         if (cols[j] !== '') {
//           // 値が空ではない場合だけkey & Valueを追加する。
//           if (keys[j].toLowerCase().endsWith('_f')) {
//             // キー名のSuffixが「_f」の場合はBoolean型に変換する。
//             line[keys[j]] = toBoolean(cols[j].toLowerCase())
//           } else if (keys[j].toLowerCase().endsWith('_n')) {
//             // [TODO] キー名のSuffixが「_n」の場合はNumber型に変換する。
//             line[keys[j]] = cols[j]
//           } else if (keys[j].toLowerCase().endsWith('_b')) {
//             // [TODO] キー名のSuffixが「_b」の場合はBinaryに変換する。
//             line[keys[j]] = cols[j]
//           } else if (keys[j].toLowerCase().endsWith('_ss')) {
//             // [TODO] キー名のSuffixが「_ss」の場合はString Setに変換する。
//             line[keys[j]] = cols[j]
//           } else if (keys[j].toLowerCase().endsWith('_ns')) {
//             // [TODO] キー名のSuffixが「_ns」の場合はNumber Setに変換する。
//             line[keys[j]] = cols[j]
//           } else if (keys[j].toLowerCase().endsWith('_bs')) {
//             // [TODO] キー名のSuffixが「_bs」の場合はBoolean Setに変換する。
//             line[keys[j]] = cols[j]
//           } else if (keys[j].toLowerCase().endsWith('_m')) {
//             // [TODO] キー名のSuffixが「_m」の場合はMap型に変換する。
//             line[keys[j]] = cols[j]
//           } else if (keys[j].toLowerCase().endsWith('_l')) {
//             // [TODO] キー名のSuffixが「_l」の場合はList型に変換する。
//             line[keys[j]] = cols[j]
//           } else {
//             line[keys[j]] = cols[j]
//           }
//         }
//       }
//       array.push(line)
//     } else {
//       if (i < lines.length - 1) {
//         // 最後の行以外の空行は許可しない。
//         // 0スタート且つヘッダ分を考慮して2を加算
//         return { error: `${i + 2}行目に空行があります。除去してください。` }
//       }
//     }
//   }
//   return { result: array }
// }

// /** ヴァリデーションチェックの条件を格納 */
// export interface ValidationCheck {
//   /** jsonのプロパティ名 */
//   key: string
//   /** 正規表現（バリデーションルール） */
//   pattern?: boolean
//   /** nullを許すかどうか */
//   isNotNull?: boolean
// }

// /**
//  * JSONデータに対してバリデーションチェックを施す。
//  * @param checkObjs バリデーションのルール
//  * @param json JSONデータ
//  * @param callback バリデーションチェックに通ったプロパティに処理を施すためのコールバック関数。json.forEach((item)=>{})のitemを引数に持つ。
//  * @returns エラーを記述した文字列で構成されたリストを返す。
//  */
// export function validationCheck(checkObjs: any, json: any, callback?: Function): string[] {
//   let lineNum = 1
//   const stackTrace: any[] = []
//   let isValid = true
//   json.forEach((item: any) => {
//     for (const checkObj of checkObjs) {
//       if (Object.prototype.hasOwnProperty.call(checkObj, 'key')) {
//         const key = checkObj.key
//         if (Object.prototype.hasOwnProperty.call(checkObj, 'pattern')) {
//           const pattern = checkObj.pattern
//           // console.log('キー: ' + key + 'の値: ' + item[key] +  'をパターン: ' + pattern + "で確認します。")
//           const regex = new RegExp(pattern)
//           if (Object.prototype.hasOwnProperty.call(item, key) && !regex.test(item[key])) {
//             // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
//             stackTrace.push(
//               `${lineNum + 1}行目の要素: ${key}の値が不正です。セットされた値: ${item[key]}、チェックパターン: ${pattern}`
//             )
//             isValid = false
//           }
//         }
//         // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
//         if (
//           Object.prototype.hasOwnProperty.call(checkObj, 'isNotNull') &&
//           checkObj.isNotNull &&
//           !Object.prototype.hasOwnProperty.call(item, key)
//         ) {
//           // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
//           stackTrace.push(`${lineNum + 1}行目に必須項目: ${key}記載されていません。`)
//           isValid = false
//         }
//       } else {
//         stackTrace.length = 0 // 意図的に配列サイズを0にすることで配列の全要素を削除
//         stackTrace.push('バリデーションチェックオブジェクトの形式が不正です。')
//         isValid = false
//       }
//     }
//     if (isValid) {
//       callback?.(item)
//     }
//     isValid = true
//     lineNum += 1
//   })
//   return stackTrace
// }

// /**
//  * QRコード(SVG)を生成する。
//  * @param text QRに埋め込むテキスト
//  * @param x x座標（QRコードを入れるエリアの左下の座標, px）
//  * @param y y座標（QRコードを入れるエリアの左下の座標, px）
//  * @param w QRコードを入れるエリアの縦の長さ(px)
//  * @param h QRコードを入れるエリアの横の長さ(px)
//  * @param mergin エリアにQRコードを入れたときの余白の長さ（QRコードの大きさはw-2*margin, h-2*margin）
//  * @returns QRコード（SVG)
//  */
// export function makeQr(text: string, x: number, y: number, w: number, _h: number, margin = 5): string {
//   // eslint-disable-next-line @typescript-eslint/no-var-requires
//   const Qrcodesvg = QrcodeSvg
//   const qrcode = new Qrcodesvg(text, w - margin * 2)
//   const strQr: string = qrcode.generate()
//   return strIns(strQr, strQr.indexOf('<svg ') + 5, `x="${x + margin}" y="${y + margin}" `)
// }

// /**
//  * エンコーディングをUnicodeに、改行コードをLF（\n）に変換する。
//  * @param obj binaryデータ(ASCII, UTF8, SJIS, EUCJP, UTF16, UTF32)
//  * @returns {result:"[変換された文字列]", error:"[エラーメッセージ]"}
//  */
// export function toUnicodeAndLf(obj: any): any {
//   let array: any = new Uint8Array(obj)
//   // eslint-disable-next-line @typescript-eslint/no-var-requires
//   const Encoding = EncodingJapanese
//   switch (Encoding.detect(array)) {
//     case 'ASCII':
//     case 'UTF8':
//     case 'SJIS':
//     case 'EUCJP':
//       if (array[0].toString(16) === 'ef' && array[1].toString(16) === 'bb' && array[2].toString(16) === 'bf') {
//         array = array.slice(3) // BOM除去
//       }
//       break
//     case 'UTF16':
//       array = new Uint16Array(obj) // UTF16と32は別の配列変換
//       if (array[0].toString(16) === 'feff') {
//         array = array.slice(1) // BOM除去
//       }
//       break
//     case 'UTF32':
//       array = new Uint32Array(obj) // UTF16と32は別の配列変換
//       if (array[0].toString(16) === 'feff') {
//         array = array.slice(1) // BOM除去
//       }
//       break
//     default:
//       // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
//       return { error: `対応していない文字コードです。検出した文字コード: ${Encoding.detect(array)}` }
//   }
//   const tempArray = Encoding.convert(array, 'UNICODE', 'AUTO') // Unicodeへエンコーディング変換
//   const buf = Encoding.codeToString(tempArray) // 文字列へ変換
//   return { result: buf.replace(/\r\n|\r/g, '\n') } // 改行コードをLFに変換
// }

/**
 * セッションストレージのkey-valueを追加または上書きする。
 * @param key 作成または更新したいキーの名称
 * @param json keyに格納または更新したい文字列。JSON.stringfyでStringに変換してから格納する。
 * @returns 格納/更新に成功した場合True、失敗した場合Falseを返す（コンソールにエラー内容を出力する）。
 */
export function tempDataSetItem(key: string, json: object | string): boolean {
  if (window.sessionStorage !== null && 'sessionStorage' in window) {
    try {
      sessionStorage.setItem(key, JSON.stringify(json))
    } catch (error) {
      console.error(error)
      return false
    }
    return true
  } else {
    console.error('セッションストレージを使用できません。')
    return false
  }
}

/**
 * セッションストレージに格納されているkey-valueを取り出す。
 * @param key keyの名称
 * @returns Jsonオブジェクトでkey-valueを返す。キーが存在しない、または存在しても読み取れなかった場合はエラーをダンプしてnullを返す。
 */
export function tempDataGetItem(key: string): any {
  if (window.sessionStorage !== null && 'sessionStorage' in window) {
    const value = sessionStorage.getItem(key)
    if (value === null) return null
    try {
      return JSON.parse(value)
    } catch (error) {
      console.error(error)
      return null
    }
  } else {
    console.error('セッションストレージを使用できません。')
    return null
  }
}

// /**
//  * セッションストレージに格納されているkey一覧を出力する。
//  * @returns key一覧をStringのリストで返す。セッションストレージが使用できなかった場合にはnullを返す（コンソールにエラー内容を出力する）。
//  */
// export function tempDataList(): string[] | null {
//   const ret: string[] = []
//   if (window.sessionStorage !== null && 'sessionStorage' in window) {
//     try {
//       for (let i = 1; i < sessionStorage.length; i++) {
//         const val = sessionStorage.key(i)
//         assert(typeof val === 'string')
//         ret.push(val)
//       }
//       return ret
//     } catch (error) {
//       console.error(error)
//       return null
//     }
//   } else {
//     console.error('セッションストレージを使用できません。')
//     return null
//   }
// }

/**
 * セッションストレージに格納されている特定のkey-valueを削除する
 * @param key 削除したいkey
 * @returns 削除に成功した場合はtrue、失敗した場合はエラーをコンソールにダンプしfalseを返す。
 */
export function tempDataRemoveItem(key: string): boolean {
  if (window.sessionStorage !== null && 'sessionStorage' in window) {
    try {
      sessionStorage.removeItem(key)

      delete sessionStorage[key]
    } catch (error) {
      console.error(error)
      return false
    }
    return true
  } else {
    console.error('セッションストレージを使用できません。')
    return false
  }
}

// /**
//  * セッションストレージに格納されているデータを全て削除する。
//  * @returns 削除が成功した場合はtrue、失敗した場合はエラーをコンソールにダンプしfalseを返す。
//  */
// export function tempDataClear(): boolean {
//   if (window.sessionStorage !== null && 'sessionStorage' in window) {
//     try {
//       sessionStorage.clear()
//     } catch (error) {
//       console.error(error)
//       return false
//     }
//     return true
//   } else {
//     console.error('セッションストレージを使用できません。')
//     return false
//   }
// }

/**
 * cookieに格納されているセッション情報を取得する。
 * @param key 取り出したいkey
 * @returns keyに対するvalueを返す
 */
export const getSessionInfo = (key: string): string => {
  let result = ''
  const sessionInfo = getAllSessionInfo()
  if (Object.prototype.hasOwnProperty.call(sessionInfo, key)) {
    result = sessionInfo[parseInt(key)]
  }
  return result
}

/**
 * cookieのセッション情報をJSON形式で全て取得する。
 * @returns セッション情報（JSON形式）
 */
export const getAllSessionInfo = (): string[] => {
  const result: string[] = []
  const allCookies = document.cookie
  if (allCookies !== '') {
    const cookies = allCookies.split('; ')
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].split('=')
      result[parseInt(cookie[0])] = decodeURIComponent(cookie[1])
    }
  }
  return result
}

/**
 * セッション情報を削除する。
 * cookieに保存されているkeyの有効期限を終了させる。
 * @param keys 消去したいkeyの文字列のリスト
 */
export function RemoveSessionInfo(keys: string[]): void {
  let cookieScope = ''

  if (MiiaFwConfig.config.authorization.accessibleDomain) {
    cookieScope += '; Domain=' + MiiaFwConfig.config.authorization.accessibleDomain
  }

  if (MiiaFwConfig.config.authorization.accessiblePath) {
    cookieScope += '; Path=' + MiiaFwConfig.config.authorization.accessiblePath
  }
  keys.forEach((key: string) => {
    document.cookie = key + '=; Max-Age=0' + cookieScope // Pathを指定してCookieを設定した場合は削除時もPathを指定する必要がある。
  })
}

// /**
//  * ArrayBufferから文字列（JSONオブジェクト）へ変換する。
//  * @param buf ArrayBuffer
//  * @returns JSONオブジェクト
//  */
// export function bufferToJson(buf: ArrayBuffer): any {
//   // 文字列が長すぎる場合、RangeError: Maximum call stack size exceeded.が発生するので1024Byte毎に分割して処理する。
//   let obj = {}
//   try {
//     const strRes = new TextDecoder().decode(buf)
//     obj = JSON.parse(strRes)
//   } catch (error) {
//     console.error(error)
//     obj = {}
//   }
//   return obj
// }

// /** ブラウザの名前 */
// export type BrowserType = 'ie' | 'edge' | 'chrome' | 'safari' | 'firefox' | 'opera' | 'unknown'

// /**
//  * ブラウザを確認する。
//  * @returns 使用しているブラウザの名前
//  */
// export function getBrowser(): BrowserType {
//   const userAgent = window.navigator.userAgent.toLowerCase()
//   if (userAgent.includes('msie') || userAgent.includes('trident')) {
//     return 'ie'
//   } else if (userAgent.includes('edge')) {
//     return 'edge'
//   } else if (userAgent.includes('chrome')) {
//     return 'chrome'
//   } else if (userAgent.includes('safari')) {
//     return 'safari'
//   } else if (userAgent.includes('firefox')) {
//     return 'firefox'
//   } else if (userAgent.includes('opera')) {
//     return 'opera'
//   } else {
//     return 'unknown'
//   }
// }

// /**
//  * 言語設定を更新する
//  * @param lang 更新する言語(eg. ja, en)
//  */
// // export function updateLang (lang: string): void {
// //   Vue.prototype.$lang = lang
// //   Vue.prototype.$i18n.locale = lang // 言語設定
// // }

// /**
//  * 数値をコンマ区切りの文字列に変換する。
//  * eg. 1000 -> 1,000; 234.5678 -> 234.567,8
//  * @param num 数値(eg. 1000)
//  * @returns コンマ区切りの文字列(eg. 1,000)
//  */
// export function addComma(num: number | string): string {
//   if (typeof num === 'number') {
//     return addComma(String(num))
//     // } else if (typeof num === 'string' && parseInt(num, 10) !== NaN) {
//   } else {
//     return num.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
//   }
// }

/**
 * nullチェックを行う
 * @param val 検査する変数
 * @param message エラーメッセージに表示する文字列
 * @throws Assertion Error発生時にThrow。
 */
export const assert: (val: unknown, message?: string) => asserts val = (val, message) => {
  if (!val) {
    throw new Error('Assertion Error' + (message ? `: ${message}` : ''))
  }
}

/**
 * セッションストレージから最後にWeb APIへアクセスした時間取得する(キー: last_access)。
 * @returns Date.now()で記録された時間を取得する。nullの場合は0を返す。
 */
export const getLastAccessDate = (): number => {
  const strLad = tempDataGetItem('last_access')
  if (strLad === null) {
    return 0
  } else {
    const lad = Number(strLad)
    if (Number.isNaN(lad)) {
      return 0
    } else {
      return lad
    }
  }
}

/**
 * バイナリ文字列をBlobに変換
 * @param str バイナリ文字列(eg. '\xe3\x81\x82')
 * @returns strをBlobに変換したもの。
 */
export function stringToBlob(str: string, fileName: string, contentType: string): Blob {
  const byteArrays: any = []

  for (let offset = 0; offset < str.length; offset += 2048) {
    const chunk = str.slice(offset, offset + 2048)
    const byteArray = Uint8Array.from(chunk, x => x.charCodeAt(0))
    byteArrays.push(byteArray)
  }
  const blob = new Blob(byteArrays, {
    lastModifiedDate: new Date(),
    name: fileName,
    type: contentType
  } as any)

  return blob
}
